import { render } from "./forgot-email-sent.vue?vue&type=template&id=2bedae72&ts=true"
import script from "./forgot-email-sent.vue?vue&type=script&lang=ts"
export * from "./forgot-email-sent.vue?vue&type=script&lang=ts"

import "./forgot-email-sent.vue?vue&type=style&index=0&id=2bedae72&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__